"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "Sarah M.",
  quote: "Invest KC has been a game-changer for my rental portfolio. Their communication and tenant screening are absolutely top-notch.",
  position: "Liberty, MO",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1584719/img/avatar_jane_d.png"
}, {
  author: "Marcus V.",
  quote: "Professional, transparent, and local. They handled my North KC duplex with incredible attention to detail and care.",
  position: "North Kansas City",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1584719/img/avatar_business_owner.png"
}, {
  author: "David L.",
  quote: "As an out-of-state investor, I need a team I can trust. Invest KC provides the complete peace of mind I was looking for.",
  position: "Platte County",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1584719/img/avatar_michael_t.png"
}];
export default function WhatOurClientsSay() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="27801" id="voices-of-partnership" ref={ref} className={cn("dark bg-background w-full py-24 lg:py-32 transition-opacity duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
      <div className="container mx-auto px-6 md:px-12">
        <div className="mb-16 text-center">
          <h2 className="text-foreground font-sans text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter">
            Voices of Partnership
          </h2>
          <div className="bg-primary mx-auto mt-6 h-1 w-24 rounded-full opacity-100" />
        </div>

        <div className="mx-auto max-w-5xl">
          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((item, i) => <CarouselItem key={i} className="md:basis-4/5 lg:basis-3/4 pl-4 md:pl-10">
                  <div data-index={i} className="flex flex-col items-center text-center px-4 py-8">
                    <Quote className="text-primary/40 mb-8 size-12 md:size-16" />
                    
                    <blockquote className="mb-10 max-w-3xl">
                      <p className="text-foreground font-serif text-2xl md:text-3xl lg:text-4xl italic leading-relaxed tracking-tight">
                        &ldquo;{item.quote}&rdquo;
                      </p>
                    </blockquote>

                    <div className="flex flex-col items-center gap-4">
                      <SafeHydrate><Avatar className="size-14 border-2 border-primary">
                        <AvatarImage src={item.avatar} alt={item.author} className="object-cover" />
                        <AvatarFallback className="bg-secondary text-secondary-foreground text-lg">
                          {item.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      
                      <div className="text-center">
                        <div className="text-foreground font-sans text-sm font-bold uppercase tracking-widest">
                          {item.author}
                        </div>
                        {item.position && <div className="text-muted-foreground mt-1 text-[0.75rem] font-mono tracking-wide">
                            {item.position}
                          </div>}
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            <div className="hidden md:block">
              <CarouselPrevious className="border-border text-foreground hover:bg-primary hover:text-primary-foreground -left-12 size-12 transition-colors" />
              <CarouselNext className="border-border text-foreground hover:bg-primary hover:text-primary-foreground -right-12 size-12 transition-colors" />
            </div>
            
            {}
            <div className="mt-8 flex justify-center gap-4 md:hidden">
               <CarouselPrevious className="static translate-y-0 translate-x-0 border-border text-foreground bg-background" />
               <CarouselNext className="static translate-y-0 translate-x-0 border-border text-foreground bg-background" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}